/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_IndonesianInputs */



/**
* | output |
* | --- |
* | "Indonesian" |
*
* @param {Speechmatics_Target_Language_IndonesianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_indonesian = /** @type {((inputs?: Speechmatics_Target_Language_IndonesianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_IndonesianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Indonesien")
	if (locale === "de") return /** @type {LocalizedString} */ ("Indonesisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("indonesiano")
	if (locale === "ru") return /** @type {LocalizedString} */ ("индонезийский")
	if (locale === "es") return /** @type {LocalizedString} */ ("indonesio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("印度尼西亚")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インドネシア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इन्डोनेशियाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("indonésio")
	return /** @type {LocalizedString} */ ("Indonesian")
});